module.exports = __webpack_public_path__ + "static/media/Template_10.71368e5e.png";